import React from "react";

function SkeletonCard() {
  return (
    <div className="rounded-[1.75rem] border border-slate-200 bg-white p-5 shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
      <div className="flex items-start justify-between gap-4">
        <div className="h-12 w-12 animate-pulse rounded-2xl bg-slate-200 dark:bg-white/10" />
        <div className="h-9 w-20 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
      </div>

      <div className="mt-4 h-5 w-3/4 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
      <div className="mt-3 h-4 w-full animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
    </div>
  );
}

function ChartSkeleton() {
  return (
    <div className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
      <div className="h-6 w-48 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
      <div className="mt-4 h-[320px] animate-pulse rounded-[1.5rem] bg-slate-200 dark:bg-white/10" />
    </div>
  );
}

function StatistiquesSkeleton() {
  return (
    <>
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
      </div>

      <div className="mt-6 grid gap-5 xl:grid-cols-2">
        <ChartSkeleton />
        <ChartSkeleton />
        <div className="xl:col-span-2">
          <ChartSkeleton />
        </div>
      </div>
    </>
  );
}

export default StatistiquesSkeleton;